'use strict';
var body = document.querySelector('.page__body');
var open = document.querySelector('.icon--menu');
var close = document.querySelector('.icon--close');
var menu = document.querySelector('.menu');
var scrollUp = document.querySelector('.page__scroll-up');
open.addEventListener('click', function() {
    body.classList.add('no-scroll');
    scrollUp.classList.add('hidden');
});
close.addEventListener('click', function() {
    body.classList.remove('no-scroll');
    scrollUp.classList.remove('hidden');
});
menu.addEventListener('click', function(event) {
    if (event.target.tagName === 'A') {
        body.classList.remove('no-scroll');
        scrollUp.classList.remove('hidden');
    }
});
var langSwitcher = document.querySelectorAll('.language-switcher');
var langElements = document.querySelectorAll('[data-lang]');
var currentLang = 'ua';
langSwitcher.forEach(function(switcher) {
    var langDropDown = switcher.querySelector('.language-switcher__dropdown-content');
    var langOptions = document.querySelectorAll('.language-switcher__lang-options');
    switcher.addEventListener('click', function() {
        langDropDown.classList.toggle('hidden');
    });
    langOptions.forEach(function(option) {
        option.addEventListener('click', function(event) {
            event.stopPropagation();
            currentLang = option.dataset.option;
            langElements.forEach(function(element) {
                if (element.dataset.lang === currentLang) element.classList.remove('hidden');
                else element.classList.add('hidden');
            });
            langDropDown.classList.add('hidden');
        });
    });
});

//# sourceMappingURL=Museum_2.5f0b47a9.js.map
